
<body>
  <footer class="footer">
    <div class="waves">
      <div class="wave" id="wave1"></div>
      <div class="wave" id="wave2"></div>
      <div class="wave" id="wave3"></div>
      <div class="wave" id="wave4"></div>
    </div>
    <ul class="social-icon">
      <li class="social-icon__item"><a class="social-icon__link" href="#">
        <i class="fa fa-twitter"></i>
        </a></li>
      <li class="social-icon__item"><a class="social-icon__link" href="#">
        <i class="fa fa-facebook"></i>
        </a></li>
      <li class="social-icon__item"><a class="social-icon__link" href="#">
        <i class="fa fa-google"></i>
        </a></li>
      <li class="social-icon__item"><a class="social-icon__link" href="#">
        <i class="fa fa-linkedin"></i>
        </a></li>
  
    </ul>
    <ul class="menu">
      <li class="menu__item"><a class="menu__link" href="#">Home</a></li>
      <li class="menu__item"><a class="menu__link" href="#">About</a></li>
      <li class="menu__item"><a class="menu__link" href="#">Services</a></li>
      <li class="menu__item"><a class="menu__link" href="#">Team</a></li>
      <li class="menu__item"><a class="menu__link" href="#">Contact</a></li>

    </ul>
    <p>&copy;2025 plateforme de traitement des réclamations | Tous droits réservés</p>
  </footer>
  <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
  <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
</body>
